export default {
  COMPLETED: 'completed',
  STARTED: 'started',
  COMPLETED_LABEL: 'Completed',
  STARTED_LABEL: 'In progress',
};
